const ITEMS = [
  "Bespoke Curation",
  "Private Concierge",
  "Hand-Wrapped Elegance",
  "Rare Sourcing",
  "Executive Gifting",
  "Personalised Moments",
  "Wrapped With Intention",
];

export default function Marquee({ dark = false, className = "" }) {
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y select-none ${
        dark ? "border-white/10 bg-espresso" : "border-chocolate/10 bg-ivory"
      } py-5 ${className}`}
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center">
            {ITEMS.map((item) => (
              <span key={`${copy}-${item}`} className="flex items-center">
                <span
                  className={`font-serif italic text-xl md:text-2xl font-light tracking-wide whitespace-nowrap px-8 ${
                    dark ? "text-champagne/90" : "text-chocolate/80"
                  }`}
                >
                  {item}
                </span>
                <svg width="10" height="10" viewBox="0 0 10 10" className="text-gold" aria-hidden="true">
                  <rect x="2" y="2" width="6" height="6" transform="rotate(45 5 5)" fill="currentColor" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
